module.exports = "/_next/static/images/229c80dcad089793948352a7c24fd6c0-secured-icon-new.svg";